import { FileDownloadService } from "@topline/services/fileDownloadService";
import { ToasterService } from "@topline/services/toasterService";
import { GridValueEditorService } from "../common/gridValueEditor/service/gridValueEditorService";
import ng from "angular";
import { ExFactoryService } from "../../services/exFactoryService";
import { angularServicesNames } from "@topline/services/angularServicesNames";
import { ExFactoryCalculationService } from "../../services/exFactoryCalculationService";


class PmforecastAndExFactoryComponentController {
    public pmforecast: $TSFixMe;
    public pmforecastAfterCorrection: $TSFixMe;
    public historicalData: $TSFixMe;
    public brand: $TSFixMe;
    public brandAfterCorrection: $TSFixMe;
    public parameters: $TSFixMe;
    public switch: $TSFixMe;
    public toggleContainer: $TSFixMe;
    public showInMilions: $TSFixMe;

    public dataToChart: $TSFixMe[] = [];
    public showYears: boolean = true;
    public isCollapsed: $TSFixMe = {};
    public options: $TSFixMe;
    public datasetOverride: $TSFixMe;
    public productSeries: $TSFixMe;
    public exfactorySeries: $TSFixMe;
    public series: $TSFixMe;
    public labelsToChart: $TSFixMe;
    public labels: $TSFixMe;
    public tableData: $TSFixMe;
    public tableQuarterData: $TSFixMe;
    public exFactorySummaryGridOptions: $TSFixMe;
    public sumVolumeExfactory: $TSFixMe;
    public sumValueExfactory: $TSFixMe;
    public sumVolumeExfactoryAfterCorrection: $TSFixMe;
    public sumValueExfactoryAfterCorrection: $TSFixMe;
    public serverOperation: $TSFixMe;
    public rowHeaderCellTemplate: string;

    static $inject = [
        "$scope",
        "$timeout",
        angularServicesNames.$translate,
        "calculationPPGService",
        ExFactoryCalculationService.componentName,
        ExFactoryService.componentName,
        "synchronousEventsBus",
        "dtpChartService",
        "PPGChartAndTableService",
        ToasterService.componentName,
        GridValueEditorService.componentName,
        FileDownloadService.componentName,
        "$q"
    ];

    constructor(
        private $scope: ng.IScope,
        private $timeout: ng.ITimeoutService,
        private $translate: ng.translate.ITranslateService,
        private calculationPPGService: $TSFixMe,
        private exFactoryCalculation: $TSFixMe,
        private exFactoryService: ExFactoryService,
        private synchronousEventsBus: $TSFixMe,
        private dtpChartService: $TSFixMe,
        private PPGChartAndTableService: $TSFixMe,
        private toasterService: ToasterService,
        private gridValueEditorService: GridValueEditorService,
        private fileDownloadService: FileDownloadService,
        private $q: ng.IQService
    ) {
        this.dataToChart = [];
        this.showYears = true;
        this.isCollapsed = {};
        this.rowHeaderCellTemplate = `<div class="ui-grid-cell-contents ui-grid-header-cell-primary-focus"><span class="ui-grid-header-cell-label ng-binding" title="{{'FORECAST.EXFACTORY_SKU' | translate}} - {{'FORECAST.EXFACTORY_ROTATION' | translate}} / {{'FORECAST.EXFACTORY_ITEMS_IN_STOCK' | translate}}">{{"FORECAST.EXFACTORY_SKU" | translate}} - {{"FORECAST.EXFACTORY_ROTATION" | translate}} <br/>/ {{"FORECAST.EXFACTORY_ITEMS_IN_STOCK" | translate}}  </span></div>`;
        this.options = {
            scales: {
                yAxes: [
                    {
                        id: "y-value",
                        display: true,
                        position: "left",
                        ticks: {
                            suggestedMin: 0
                        }
                    }
                ]
            }
        };
    }

    $onInit() {
        this.$scope.$on("LanguageChanged", () => this.resetChartTranslations());
        this.resetChartTranslations();

        this.$scope.$watch(
            () => this.pmforecast,
            (newVal: $TSFixMe) => {
                if (newVal) {
                    this.recalculateData();
                }
            },
            true
        );
        this.$scope.$watch(() => this.brand, (newVal: $TSFixMe) => {
            if (newVal) {
                this.refreshDebounce();
                for (let i = 0; i < this.brand.skus.length; i++) {
                    this.$scope.$watch(() => this.brand.skus[i].forecast.exFactory.rotation, () =>
                        this.refreshDebounce()
                    );
                    this.$scope.$watch(() => this.brand.skus[i].forecast.exFactory.launchDate, () =>
                        this.refreshDebounce()
                    );
                    this.$scope.$watch(() => this.brand.skus[i].forecast.exFactory.itemsInStock, () =>
                        this.refreshDebounce()
                    );
                }
            }
        });
        this.$scope.$watch(() => this.switch, (newVal: $TSFixMe) => {
            if (newVal) this.recalculateData();
        });

        this.synchronousEventsBus.$on("skuVolumeForecastChanged", () => this.reloadExFactory());
        this.synchronousEventsBus.$on("skuDotForecastChanged", () => this.reloadExFactory());
        this.synchronousEventsBus.$on("sku.SkuVolumeCalculated", () => this.reloadExFactory());
    }

    private refreshDebounce() {
        if (angular.isDefined((this.$scope as any).watchTimeout)) {
            this.$timeout.cancel((this.$scope as any).watchTimeout);
        }
        (this.$scope as any).watchTimeout = this.$timeout(() => {
            this.reloadExFactory();
        }, 300);
    }

    private resetChartTranslations() {
        this.$translate([
            "FORECAST.PRODUCT.PPG_CHART.PRODUCT",
            "FORECAST.EX_FACTORY_TITLE",
            "FORECAST.EX_FACTORY_AFTER_CORRECTION",
            "FORECAST.PRODUCT.PPG_CHART.PRODUCT_AFTER_CORRECTION"
        ]).then((translations: $TSFixMe) => {
            this.datasetOverride = [
                {
                    label: translations["FORECAST.PRODUCT.PPG_CHART.PRODUCT"],
                    borderColor: "rgba(198, 72, 3, 0.6)",
                    backgroundColor: "rgba(198, 72, 3, 0.6)"
                },
                {
                    label: translations["FORECAST.EX_FACTORY_TITLE"],
                    borderColor: "rgba(89, 62, 28, 0.6)",
                    backgroundColor: "rgba(89, 62, 28, 0.6)"
                },
                {
                    label: translations["FORECAST.PRODUCT.PPG_CHART.PRODUCT_AFTER_CORRECTION"],
                    hidden: true
                },
                {
                    label: translations["FORECAST.EX_FACTORY_AFTER_CORRECTION"],
                    hidden: true
                }
            ];

            this.productSeries = translations["FORECAST.PRODUCT.PPG_CHART.PRODUCT"];
            this.exfactorySeries = translations["FORECAST.EX_FACTORY_TITLE"];
            this.series = [this.productSeries, this.exfactorySeries];
        });
    }

    private recalculateData() {
        this.labelsToChart = this.dtpChartService.preparePeriodsAndLabels(
            this.parameters.historicalDataStart,
            this.parameters.forecastEndDate
        ).periods;
        this.labels = this.PPGChartAndTableService.prepareLabelsToPPG(
            this.parameters.historicalDataStart,
            this.parameters.forecastEndDate
        );

        const historicalData =
            this.historicalData && this.historicalData.length > 0
                ? this.historicalData
                : _.times(this.labelsToChart.length - (this.pmforecast?.length ?? 0), _.constant(0));

        const data: $TSFixMe = this.prepareCalculatedData(
            historicalData,
            this.pmforecast,
            this.sumVolumeExfactory,
            this.sumValueExfactory
        );
        const dataAfterCorrection: $TSFixMe = this.prepareCalculatedData(
            historicalData,
            this.pmforecastAfterCorrection,
            this.sumVolumeExfactoryAfterCorrection,
            this.sumValueExfactoryAfterCorrection
        );

        if (!this.switch) {
            this.dataToChart = _.filter(
                [
                    data.pmForecast,
                    data.sumVolumeExfactory,
                    dataAfterCorrection.pmForecast,
                    dataAfterCorrection.sumVolumeExfactory
                ],
                (x: $TSFixMe) => angular.isArray(x)
            );
        } else {
            this.dataToChart = _.filter(
                [
                    data.pmForecast,
                    data.sumValueExfactory,
                    dataAfterCorrection.pmForecast,
                    dataAfterCorrection.sumValueExfactory
                ],
                (x: $TSFixMe) => angular.isArray(x)
            );
        }

        this.tableData = _.filter(
            [
                {
                    header: this.$translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT"),
                    data: data.pmForecastSumYearly
                },
                {
                    header: this.$translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT_AFTER_CORRECTION"),
                    data: dataAfterCorrection.pmForecastSumYearly
                },
                {
                    header: this.$translate.instant("FORECAST.EX_FACTORY_TITLE"),
                    data: !this.switch ? data.exfactorySumYearlyVolume : data.exfactorySumYearlyValue
                },
                {
                    header: this.$translate.instant("FORECAST.EX_FACTORY_AFTER_CORRECTION"),
                    data: !this.switch
                        ? dataAfterCorrection.exfactorySumYearlyVolume
                        : dataAfterCorrection.exfactorySumYearlyValue
                }
            ],
            (x: $TSFixMe) => angular.isArray(x.data)
        );

        this.tableQuarterData = _.filter(
            [
                {
                    header: this.$translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT"),
                    data: data.pmForecastSumQuarters
                },
                {
                    header: this.$translate.instant("FORECAST.PRODUCT.PPG_CHART.PRODUCT_AFTER_CORRECTION"),
                    data: dataAfterCorrection.pmForecastSumQuarters
                },
                {
                    header: this.$translate.instant("FORECAST.EX_FACTORY_TITLE"),
                    data: !this.switch ? data.exfactorySumQuarterVolume : data.exfactorySumQuarterValue
                },
                {
                    header: this.$translate.instant("FORECAST.EX_FACTORY_AFTER_CORRECTION"),
                    data: !this.switch
                        ? dataAfterCorrection.exfactorySumQuarterVolume
                        : dataAfterCorrection.exfactorySumQuarterValue
                }
            ],
            (x: $TSFixMe) => angular.isArray(x.data)
        );
    }

    private prepareCalculatedData(
        historicalData: $TSFixMe,
        pmForecast: $TSFixMe,
        sumVolumeExfactory: $TSFixMe,
        sumValueExfactory: $TSFixMe
    ) {
        if (angular.isUndefinedOrNull(pmForecast)) {
            return {};
        }

        const pmForecastWithHisotry = historicalData.concat(pmForecast);

        const result: any = {
            pmForecast: pmForecastWithHisotry,
            pmForecastSumYearly: this.calculationPPGService.sumBy(
                pmForecastWithHisotry,
                this.parameters.historicalDataStart,
                (month: $TSFixMe) => month == 0
            ),
            pmForecastSumQuarters: this.calculationPPGService.sumBy(
                pmForecastWithHisotry,
                this.parameters.historicalDataStart,
                (month: $TSFixMe) => month % 3 == 0
            ),
            sumVolumeExfactory,
            sumValueExfactory
        };

        if (!angular.isUndefinedOrNull(sumValueExfactory)) {
            result.exfactorySumYearlyValue = this.calculationPPGService.sumBy(
                sumValueExfactory,
                this.parameters.historicalDataStart,
                (month: $TSFixMe) => month == 0
            );
            result.exfactorySumQuarterValue = this.calculationPPGService.sumBy(
                sumValueExfactory,
                this.parameters.historicalDataStart,
                (month: $TSFixMe) => month % 3 == 0
            );
        }

        if (!angular.isUndefinedOrNull(sumVolumeExfactory)) {
            result.exfactorySumYearlyVolume = this.calculationPPGService.sumBy(
                sumVolumeExfactory,
                this.parameters.historicalDataStart,
                (month: $TSFixMe) => month == 0
            );
            result.exfactorySumQuarterVolume = this.calculationPPGService.sumBy(
                sumVolumeExfactory,
                this.parameters.historicalDataStart,
                (month: $TSFixMe) => month % 3 == 0
            );
        }

        return result;
    }

    public exportTable = () => {
        this.toasterService.showReportGenerateBusyIndicator(
            () =>
                this.fileDownloadService.exportTable("table.xlsx", {
                    columns: this.labels,
                    rows: this.tableData.map((x: $TSFixMe) => {
                        return {
                            header: x.header,
                            values: x.data
                        };
                    })
                }),
            "EXCEL_EXPORT_GENERATING",
            "EXCEL_EXPORT_GENERATED"
        );
    };

    private reloadExFactory() {
        if (!this.brand) return;

        this.labelsToChart = this.dtpChartService.preparePeriodsAndLabels(
            this.parameters.forecastStartDate,
            this.parameters.forecastEndDate
        ).periods;
        this.labels = this.PPGChartAndTableService.prepareLabelsToPPG(
            this.parameters.forecastStartDate,
            this.parameters.forecastEndDate
        );
        this.serverOperation = this.calculateExFactory().then(results => {
            this.exFactorySummaryGridOptions = {
                gridName: "exFactorySummary",
                header: this.gridValueEditorService.prepareHeaderData(
                    this.parameters.historicalDataStart,
                    this.parameters.forecastEndDate
                ),
                readOnly: true,
                headerTitle: this.rowHeaderCellTemplate
            };

            if (!this.switch) {
                this.exFactorySummaryGridOptions.gridData = results[0].skusVolume;
            } else {
                this.exFactorySummaryGridOptions.gridData = results[0].skusValue;
            }
            this.sumVolumeExfactory = this.exFactoryCalculation.sumExFactory(results[0].skusVolume);
            this.sumValueExfactory = this.exFactoryCalculation.sumExFactory(results[0].skusValue);

            if (results.length > 1) {
                this.assingAfterForrectionData(results[1]);
            }

            this.recalculateData();
        });
    }

    private assingAfterForrectionData(exFactoryData: $TSFixMe) {
        this.sumVolumeExfactoryAfterCorrection = this.exFactoryCalculation.sumExFactory(
            exFactoryData.skusVolume
        );
        this.sumValueExfactoryAfterCorrection = this.exFactoryCalculation.sumExFactory(exFactoryData.skusValue);
    }

    private calculateExFactory() {
        const promises = [
            this.exFactoryService.calculateExFactory(
                this.parameters.forecastMethod.methodId,
                this.parameters.forecastType.typeId,
                this.parameters.forecastStartDate,
                this.parameters.historicalDataStart,
                this.brand.skus
            )
        ];
        if (this.brandAfterCorrection) {
            promises.push(
                this.exFactoryService.calculateExFactory(
                    this.parameters.forecastMethod.methodId,
                    this.parameters.forecastType.typeId,
                    this.parameters.forecastStartDate,
                    this.parameters.historicalDataStart,
                    this.brandAfterCorrection.skus
                )
            );
        }
        return this.$q.all(promises);
    }
}

export class PmforecastAndExFactoryComponent implements ng.IComponentOptions {
    static componentName = "pmforecastAndExfactory";
    bindings = {
        pmforecast: "<",
        pmforecastAfterCorrection: "<",
        historicalData: "<",
        brand: "<",
        brandAfterCorrection: "<",
        parameters: "<",
        switch: "<",
        toggleContainer: "<",
        showInMilions: "<"
    };
    controller = PmforecastAndExFactoryComponentController;
    template = require("./pmforecastAndExFactoryComponent.html");
}

angular.module("topline.modules").component(PmforecastAndExFactoryComponent.componentName, new PmforecastAndExFactoryComponent());
